import { TableFiltersState } from 'types/common';

export const TABLE_INITIAL_FILTERS: TableFiltersState = {
    from: '',
    to: '',
    status: [],
};
